import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from '@angular/router';

import { AuthService } from "app/shared/services/auth/auth.service";
import { ActivityVerify } from "../shared/model/activity-verify.model";
import { ActivityVerifyService } from "../shared/service/activity-verify.service";

@Component({
    selector: 'app-activity-verify',
    templateUrl: './activity-verify.component.html',
    styleUrls: ['./activity-verify.component.scss']
})

export class ActivityVerifyComponent implements OnInit {
    
    activityVerify: ActivityVerify =  new ActivityVerify();
    logo: string = '';
    private domain: string = '';
    private identifier: string = '';
    readonly logoDefaultSrc = '../../../assets/img/metroex_header.png';
    readonly accessFooter = '../../../../assets/img/access_metroex.png';
    readonly notInformed = '[Não Informado]';
    
    constructor(
        private activityVerifyService: ActivityVerifyService,
        private authService: AuthService,
        private route: ActivatedRoute,
    ){}

    ngOnInit(): void {
        this.domain = this.route.snapshot.params['domain'];
        this.identifier = this.route.snapshot.params['identifier'];
        this.authService.getLoginLogo(this.domain).subscribe(data => {
            this.logo = JSON.parse(data).BytesConverted;
        });
        this.activityVerifyService.get(this.domain, this.identifier)
            .subscribe(data => {
                this.activityVerify = data;
        });
    }

    logoShow(): string {
        return this.logo !== '' ? 'data:image/png;base64,' + this.logo : this.logoDefaultSrc;
    }

    getLoginUrl(): string {
        return 'https://webview.metroex.com.br/' + this.domain;
    }
}


// WEBPACK FOOTER //
// ./src/app/verify/activity-verify/activity-verify.component.ts